import { HEROS_SERVICE } from "@/services/heros.service.js";

const state = { listOutput: null};

const actions = {
    getList({ dispatch, commit }, inputGetHeros) {
        dispatch('alert/clear', null, { root: true });
        commit('listRequest');
        
        HEROS_SERVICE.list(inputGetHeros)
            .then(
                output => {
                    commit('listSuccess', output);
                },
                error => {
                    commit('listFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
};

const mutations = {
    /* List */
    listRequest(state) {
        state.listOutput = null;
    },
    listSuccess(state, output) {
        state.listOutput = output;
    },
    listFailure(state) {
        state.listOutput = false;
    },
};

export const heros = {
    namespaced: true,
    state,
    actions,
    mutations
};